import { render, staticRenderFns } from "./ProcuratorsForm.vue?vue&type=template&id=77f7a9c3&"
import script from "./ProcuratorsForm.vue?vue&type=script&lang=js&"
export * from "./ProcuratorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports